// SearchHeader — Presentational header row: location label, filters toggle,
// clear-search button, and the collapsible FiltersPanel.
//
// Extracted VERBATIM from `components/RestaurantSearch.js` (behavior-preserving
// refactor, issue #240). Render-only, wrapped in React.memo. Markup, styles,
// icons, text, and hover handlers are identical to the source. The
// `displayLocation` derivation is delegated to `getDisplayLocation` from the
// logic layer (task 15.2), which is byte-identical to the source inline
// expression.
//
// Validates: Requirements 3.3, 3.4, 1.2, 1.6

import React from 'react';
import { MapPin, Filter, X } from 'lucide-react';
import { getDisplayLocation } from '../logic/displayLocation';
import { FiltersPanel } from './FiltersPanel';

export const SearchHeader = React.memo(function SearchHeader({
  searchLocation, selectedHotel, location, showFilters, setShowFilters,
  hasActiveFilters, filters, onFilterChange, onClearFilters, onClearSearch
}) {
  const displayLocation = getDisplayLocation(searchLocation, selectedHotel, location);

  return (
    <div style={{ marginBottom: '20px' }}>
      <div style={{
        display: 'flex', gap: '12px', alignItems: 'center', marginBottom: '12px'
      }}>
        <div style={{
          flex: 1, display: 'flex', alignItems: 'center', gap: '8px',
          padding: '10px 12px', border: '1px solid #d1d5db',
          borderRadius: '6px', backgroundColor: '#ffffff'
        }}>
          <MapPin size={18} color="#6b7280" />
          <span style={{ fontSize: '14px', color: '#6b7280' }}>{displayLocation}</span>
        </div>
        <button
          onClick={() => setShowFilters(!showFilters)}
          style={{
            padding: '10px 16px', border: '1px solid #d1d5db', borderRadius: '6px',
            backgroundColor: '#ffffff', cursor: 'pointer', display: 'flex',
            alignItems: 'center', gap: '6px',
            color: hasActiveFilters ? '#d32f2f' : '#6b7280'
          }}
        >
          <Filter size={18} />
          {hasActiveFilters && (
            <span style={{
              width: '8px', height: '8px', borderRadius: '50%',
              backgroundColor: '#d32f2f', marginLeft: '-4px', marginTop: '-8px'
            }} />
          )}
        </button>
        <button
          onClick={onClearSearch}
          style={{
            padding: '10px 16px', border: '1px solid #dc2626', borderRadius: '6px',
            backgroundColor: '#ffffff', cursor: 'pointer', display: 'flex',
            alignItems: 'center', gap: '6px', color: '#dc2626',
            fontWeight: '500', fontSize: '14px'
          }}
          onMouseOver={(e) => { e.target.style.backgroundColor = '#fef2f2'; }}
          onMouseOut={(e) => { e.target.style.backgroundColor = '#ffffff'; }}
        >
          <X size={18} />
          Clear Search
        </button>
      </div>

      {showFilters && (
        <FiltersPanel
          filters={filters}
          hasActiveFilters={hasActiveFilters}
          onFilterChange={onFilterChange}
          onClearFilters={onClearFilters}
        />
      )}
    </div>
  );
});

export default SearchHeader;
